"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ReadinessCheckerAudioTest = require("./ReadinessCheckerAudioTest");
Object.keys(_ReadinessCheckerAudioTest).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ReadinessCheckerAudioTest[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ReadinessCheckerAudioTest[key];
    }
  });
});